import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterHorizontalFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.66634 2C7.42378 2 6.37971 2.84985 6.08369 4H1.99967C1.63148 4 1.33301 4.29848 1.33301 4.66667C1.33301 5.03486 1.63148 5.33333 1.99967 5.33333H6.08369C6.37971 6.48349 7.42378 7.33333 8.66634 7.33333H9.33301C10.8058 7.33333 11.9997 6.13943 11.9997 4.66667C11.9997 3.19391 10.8058 2 9.33301 2H8.66634Z",
			fill: "#2563EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.333 4C12.9648 4 12.6663 4.29848 12.6663 4.66667C12.6663 5.03486 12.9648 5.33333 13.333 5.33333H13.9997C14.3679 5.33333 14.6663 5.03486 14.6663 4.66667C14.6663 4.29848 14.3679 4 13.9997 4H13.333Z",
			fill: "#2563EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99967 8.66667C4.75711 8.66667 3.71305 9.51652 3.41702 10.6667H1.99967C1.63148 10.6667 1.33301 10.9651 1.33301 11.3333C1.33301 11.7015 1.63148 12 1.99967 12H3.41702C3.71305 13.1502 4.75711 14 5.99967 14H6.66634C8.1391 14 9.33301 12.8061 9.33301 11.3333C9.33301 9.86057 8.1391 8.66667 6.66634 8.66667H5.99967Z",
			fill: "#2563EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6663 10.6667C10.2982 10.6667 9.99967 10.9651 9.99967 11.3333C9.99967 11.7015 10.2982 12 10.6663 12H13.9997C14.3679 12 14.6663 11.7015 14.6663 11.3333C14.6663 10.9651 14.3679 10.6667 13.9997 10.6667H10.6663Z",
			fill: "#2563EB"
		})
	]
});
const ForwardRef = forwardRef(SvgFilterHorizontalFilled);
export default ForwardRef;
